import { Surface } from '@heroui/react'

import type { DriverExpense } from '@/types/driver'

interface TimesheetExpenseRowProps {
  expense: DriverExpense;
}

export function TimesheetExpenseRow({ expense }: TimesheetExpenseRowProps) {
  return (
    <Surface
      className="flex flex-row justify-between items-center p-2 w-full rounded-xl"
      variant="tertiary"
    >
      <div className="font-medium text-sm text-foreground">{expense.name}</div>
      <div className="uppercase text-xs font-bold px-3 py-1 bg-default-200 rounded-md text-foreground/80 shrink-0">
        {expense.country}
      </div>
    </Surface>
  )
}
